import React from "react";
import PropTypes from "prop-types";

import * as Theme from "../../../../App/Theme";

import HelpIcon from "../../../../Img/DM/Help 32 n p.png";

import TComboBox from "../../../../Library/ComboBoxes/TComboBox";
import TLabel from "../../../../Library/Labels/TLabel";
import TDialog from "../../../../Library/Dialogs/TDialog";

import { shouldComponentUpdateGB } from "../../../GB/NonComponents/GBUtil";

import * as DMConst from "../../NonComponents/DMConst";
import DMAPA2Chart from "../../Charts/DMAPA2Chart";

class DMAPA2Form extends React.Component {
    static propTypes = {
        navComboBoxHeight: PropTypes.number,
        results: PropTypes.object,
        selectedSNU_CurrID: PropTypes.number,
    };

    static defaultProps = {
        navComboBoxHeight: 35,
        results: {},
        selectedSNU_CurrID: 1,
    };

    constructor(props) {
        super(props);

        this.state = {
            finalYear: DMConst.lastYearProgData,
            showHelpDialog: false,
        };
    }

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onFinalYearComboBoxChange = (value, text, info) => {
        try {
            this.setState({
                finalYear: text,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onHelpBtnClick = () => {
        try {
            this.setState({
                showHelpDialog: !this.state.showHelpDialog,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const props = this.props;
            const results = props.results;
            const res = results[DMConst.rResult12];
            const selectedSNU_CurrID = props.selectedSNU_CurrID;
            const navComboBoxHeight = props.navComboBoxHeight;

            const state = this.state;
            const finalYear = state.finalYear;
            const showHelpDialog = state.showHelpDialog;

            const title = res[DMConst.rTitle];

            const chart = (
                <DMAPA2Chart
                    finalYear={finalYear}
                    navComboBoxHeight={navComboBoxHeight}
                    results={results}
                    selectedSNU_CurrID={selectedSNU_CurrID}
                />
            );

            const finalYearLabel = (
                <TLabel
                    caption={"End of"}
                    style={{
                        marginLeft: 30,
                    }}
                />
            );

            let year1DIntArray = [];

            for (let t = DMConst.firstYear; t <= DMConst.lastPossibleTargetYear; t++) {
                year1DIntArray.push(t.toString());
            }

            const finalYearComboBox = (
                <TComboBox
                    onChange={this.onFinalYearComboBoxChange}
                    itemIndex={finalYear - DMConst.firstYear}
                    items={year1DIntArray}
                    outerStyle={{
                        marginLeft: 5,
                        width: Theme.finalYearComboBoxWidth,
                    }}
                    style={Theme.finalYearComboBoxStyle}
                />
            );

            const configLeftDiv = (
                <div style={Theme.configLeftDivStyle}>
                    {finalYearLabel}
                    {finalYearComboBox}
                </div>
            );

            const helpBtn = (
                <div>
                    <img
                        alt="" // to avoid hint
                        onClick={this.onHelpBtnClick}
                        style={Theme.helpBtnImgStyle}
                        src={HelpIcon}
                    />
                </div>
            );

            const helpDialog = (
                <TDialog
                    caption={title}
                    content={
                        <div>
                            The uptake rate is the number of circumcisions in a given age group in a given year divided
                            by the number of uncircumcised men in that age group and year (represented as a percentage).
                        </div>
                    }
                    actions={["mrOK"]}
                    onClose={this.onHelpBtnClick}
                    style={{
                        width: 1000,
                    }}
                    maxWidth={"xl"}
                    visible={showHelpDialog}
                />
            );

            const configDiv = (
                <div style={Theme.configDivStyle}>
                    {configLeftDiv}
                    {helpBtn}
                </div>
            );

            return (
                <div>
                    {chart}
                    {helpDialog}
                    {configDiv}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"DMAPA2FormDiv"}
                    key={"DMAPA2FormDiv"}
                >
                    <h3 key={"DMAPA2FormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMAPA2Form;
